import React, { FC, ReactElement } from "react"

import { ActionIcon, Card, CardProps, Group, Menu, MenuItemProps, Stack, Text } from "@mantine/core"
import { IconDotsVertical, TablerIconsProps } from "@tabler/icons-react"
import ReactECharts from "echarts-for-react"
import { EChartsOption } from "echarts-for-react/src/types"

type ChartCardProps = Omit<CardProps, "children"> & {
    label: string
    option: EChartsOption
    icon?: FC<TablerIconsProps>
    actions?: ReactElement[]
    menu?: MenuItemProps[]
}

const ChartCard: FC<ChartCardProps> = ({ label, option, icon: Icon, actions, menu, h, ...props }) => {
    return (
        <Card withBorder {...props} h={h ?? "100%"}>
            <Stack h="100%">
                <Group align="center" noWrap>
                    <Text
                        weight={500}
                        color="dimmed"
                        mr="auto"
                        sx={theme => ({ fontFamily: theme.headings.fontFamily, alignSelf: "start" })}
                    >
                        <Group spacing="xs">
                            {Icon && <Icon />}
                            {label}
                        </Group>
                    </Text>
                    {actions}
                    {menu && (
                        <Menu shadow="lg" width={180}>
                            <Menu.Target>
                                <ActionIcon variant="subtle">
                                    <IconDotsVertical size={18} />
                                </ActionIcon>
                            </Menu.Target>
                            <Menu.Dropdown>
                                {menu.map((props, index) => (
                                    <Menu.Item {...props} key={index} />
                                ))}
                            </Menu.Dropdown>
                        </Menu>
                    )}
                </Group>
                <ReactECharts option={option} />
            </Stack>
        </Card>
    )
}

export default ChartCard
